import { formatDayMonthYear } from '../garage/format';

const decimal = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const percent = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

export const formatScore = (value) => decimal.format(Number(value) || 0);

export const formatPercent = (value) => `${percent.format(Number(value) || 0)}%`;

const toDate = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};

// "12 set 2026"
export const formatEvaluationDate = (value) => formatDayMonthYear(toDate(value));

// Resumo calculado das proprias avaliacoes: o que a tela mostra bate com a lista.
export function summarize(list) {
  const total = list.length;
  if (!total) return { total: 0, indicatePercent: 0, product: 0, price: 0, average: 0 };
  const sum = (pick) => list.reduce((acc, item) => acc + pick(item), 0);
  const product = sum((item) => item.ratingProduct) / total;
  const price = sum((item) => item.ratingPrice) / total;
  return {
    total,
    indicatePercent: (list.filter((item) => item.indicate).length / total) * 100,
    product,
    price,
    average: (product + price) / 2,
  };
}
